/* eslint-disable react/prop-types */
import React from 'react';
import { Tag, Tooltip } from 'antd';
import { presentacionEstatusTimbrado } from 'utils/estatusTimbrado';

/**
 * Estatus de timbrado (recibo o nómina) como Tag de color. Si el estatus tiene un texto de
 * ayuda (Pendiente de Conciliar), se muestra en un Tooltip. Sin descripción del catálogo,
 * se muestra el texto plano ('—').
 */
const EstatusTimbradoTag = ({ id, catalogo }) => {
  const {
    texto, color, conDescripcion, ayuda,
  } = presentacionEstatusTimbrado(id, catalogo);
  if (!conDescripcion) return texto;
  const tag = <Tag color={color}>{texto}</Tag>;
  return ayuda ? <Tooltip title={ayuda}>{tag}</Tooltip> : tag;
};

export default EstatusTimbradoTag;
